export default __webpack_public_path__ + "static/media/landscape_tv.641fb7f5.png";